import { ModuleResource } from 'dashboard/modules/Resource';

export interface ModuleResourceTransaction extends ModuleResource {
  'field-key': 'transactions';
  'txn-type': string | null;
  'hide-empty-attributes'?: boolean;
  attributes: string[];
}

export enum ResourceTransactionAttribute {
  Id = 'id',
  CreatedAt = 'created-at',
  Status = 'status',
  Tags = 'tags',
}
